export default ngInject(function(Supplier) {
  this.loading = true;

  Supplier.getSuppliers()
    .then((suppliers) => {
      this.suppliers = suppliers;
      this.supplierSlugs = [
        ...Array.from(this.suppliers.map((s) => s.name)),
        ...Array.from(this.suppliers.map((s) => s.slug)),
      ];
    })
    .finally(() => (this.loading = false));

  const matchString = (value) =>
    !this.search ||
    !value ||
    this.search === '' ||
    value.toLowerCase().includes(this.search.toLowerCase());

  this.searchForNameOrSlug = (supplier) => matchString(supplier.name) || matchString(supplier.slug);

  return this; // http://stackoverflow.com/questions/28953289/using-controller-as-with-the-ui-router-isnt-working-as-expected
});
